import { useSetAtom } from 'jotai'
import React from 'react'

import { surveyGroupFilterKeyAtom } from '~/atoms'
import { useCurrentSurveyGroup } from '~/hooks/useCurrentSurveyGroup'

/**
 * ユーザーや現在のサーベイが更新されたらサーベイフィルターキーをatomに設定するカスタムフックです。
 */
export const useSetSurveyGroupFilterKeyEffect = () => {
  const setSurveyGroupFilterKey = useSetAtom(surveyGroupFilterKeyAtom)
  const currentSurveyGroup = useCurrentSurveyGroup()

  React.useEffect(() => {
    setSurveyGroupFilterKey(currentSurveyGroup?.id)
  }, [currentSurveyGroup?.id, setSurveyGroupFilterKey])
}
